@if (transaction.type === PaymentType.REFUND && transaction.purposeId) {
  <ap-panel *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'>
    <ap-panel-content>
      <div class='row initial-transaction-container'>
        <div class='col-sm-12 col-md-12 col-xs-12'>
          <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.INITIAL_TRANSACTION_REFUNDED.TITLE' | translate }}</span>
          <div class='col-sm-6 col-md-6 col-xs-6 initial-transaction-section'>
            <!-- TRANSACTION REFERENCE -->
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.INITIAL_TRANSACTION_REFUNDED.TITLE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-7'>
                @if (transaction?.purposeId) {
                  <code>{{ transaction.purposeId | noData }}</code>
                  <button (click)='navigateToTransactionDetails(transaction.purposeId)' class='btn btn-xs btn-default user-button-dialog'>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.INITIAL_TRANSACTION_REFUNDED.BUTTONS.DETAILS' | translate }}</button>
                } @else {
                  -
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
